export class CustomersQuery {

}

export const KEYS = {
  TEXT: 'text'
};
